import gql from 'graphql-tag';

import { CUSTOMER_PERSONA_FRAGMENT } from 'src/graphql/customerPersona/schema';
import { FRAGMENT_CONTENT_MARKUP, FRAGMENT_IMAGE_OVERLAY_TEXT } from 'src/graphql/schema';

export const FRAGMENT_LONG_FORM_VARIABLES = gql`
  fragment LongFormVariables on LongFormVariables {
    info
    title
  }
`;

export const FRAGMENT_CONTEXT_ITEM = gql`
  fragment ContextItem on ContextItem {
    name
    title
    text
    allInstructionsData
    description
  }
`;

export const FRAGMENT_MEDIA_INFO = gql`
  fragment MediaInfo on MediaInfo {
    type
    path
    imageStyleId
    imageDescription
    imageOverlayProperties {
      ...ImageOverlayText
    }
  }
  ${FRAGMENT_IMAGE_OVERLAY_TEXT}
`;

export const FRAGMENT_LONG_FORM_BUILDER_PROJECT = gql`
  fragment LongFormBuilderProject on LongFormBuilderProject {
    language
    customerMultiPromptTemplateId
    contentImproverData
    associatedResources {
      id
      text
      type
    }
    brandVoiceIdsForBrandTerms
    customerPersona {
      ...CustomerPersona
    }
    wordCount
    tovInput
    blocks {
      blockId
      allInstructionsData
      structureInstructionsData
      generationTool
      name
      order
      tovInput
      language
      imageAspectRatio
      imageStyleId
      imageOverlayProperties {
        headline
        subHeadline
        callToAction
      }
    }
    promptFields
    contextQuestions {
      ...ContextItem
    }
    descriptionAllInstructionsData
    variables {
      ...LongFormVariables
    }
    structureInstructionsData
    currentCreationJobId
  }
  ${FRAGMENT_LONG_FORM_VARIABLES}
  ${FRAGMENT_CONTEXT_ITEM}
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

export const FRAGMENT_PROJECT_LONG_FORM_SECTION = gql`
  fragment LongFormSection on LongFormBuilderOutlineSection {
    id
    projectId
    name
    headline
    status
    content
    contentMarkup {
      ...ContentMarkup
    }
    originalSectionId
    manualKeywords
    instructions
    generationLength
    textStatus
    allInstructionsData
    assetType
    generationTool
    score
    performancePredictionsScoreLocked
    engagementScoreSupportSize
    customFormatIds
    mediaInfo {
      ...MediaInfo
    }
  }
  ${FRAGMENT_CONTENT_MARKUP}
  ${FRAGMENT_MEDIA_INFO}
`;

export const FRAGMENT_LONG_FORM_BUILDER_DRAFT = gql`
  fragment LongFormBuilderDraft on LongFormBuilderDraft {
    id
    projectId
    draftId
    originalDraftIndex
    status
    chainId
    name
    generationInfo
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
    currentGenerationJobId
  }
`;

export const FRAGMENT_LONG_FORM_SUGGEST_CONTENT = gql`
  fragment SuggestLongFormBuilderContent on SuggestLongFormBuilderContent {
    copyText
    fullSectionHtml
    fullSectionMarkup {
      ...ContentMarkup
    }
    mainFewerReceivedReason
    blacklistMatches
    score
  }
  ${FRAGMENT_CONTENT_MARKUP}
`;

export const FRAGMENT_IMPROVE_LONG_FORM_FROM_CONTENT_RESULT = gql`
  fragment ImproveLongFormFromContentResult on ImproveLongFormFromContentResult {
    status
    originalDraftIndex
    originalDraftSections {
      ...LongFormSection
    }
    improvedDraft {
      ...LongFormBuilderDraft
    }
    improvedDraftSections {
      ...LongFormSection
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;
